import React from 'react';
import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import OrganisationUnitScenario from 'features/residents/models/organisation-unit-scenario';
import { ScenarioActiveOption } from 'features/residents/models/scenario-active-option';
import AlarmActiveSelect from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/alarm-active-select';
import { useAlarmOnlyScenarioConfiguration } from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/alarm-only-scenario-configuration/hooks';
import TimeFrames from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/time-frames/time-frames';
import styles from './alarm-only-scenario-configuration.module.scss';

type Props = {
  organisationUnitScenario?: OrganisationUnitScenario;
  scenarioTitle: string;
  index: number;
};

const AlarmOnlyScenarioConfiguration = ({ organisationUnitScenario, scenarioTitle, index }: Readonly<Props>): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');

  const { configuration, timeFrameValuesChanged } = useAlarmOnlyScenarioConfiguration(index, organisationUnitScenario);

  const activeOptions = [
    <MenuItem data-testid={`alarm-active`} key={`alarm-active`} value={ScenarioActiveOption.AlarmsOnly}>
      {t('scenarioConfiguration.alarmActive')}
    </MenuItem>,
  ];

  return (
    <div className={styles.container}>
      <div className={styles.restoreRow}>
        <Typography variant="subtitle1">{`${scenarioTitle} ${t('scenarioConfiguration.scenarioDescription')}`}</Typography>
      </div>
      <div className={styles.alarmActiveRow}>
        <AlarmActiveSelect
          label={t('scenarioConfiguration.alarmActiveLabel')}
          value={ScenarioActiveOption.AlarmsOnly}
          options={activeOptions}
          disabled
          className={styles.alarmActiveSelect}
        />
      </div>

      <TimeFrames
        activeAllDay={configuration.sendAlarmAllDay}
        index={index}
        timeFrames={configuration.timeFrames}
        valuesChanged={timeFrameValuesChanged}
        timeFramesDescription={t('scenarioConfiguration.timeFramesDescriptionAlarm')}
      />
    </div>
  );
};

export default AlarmOnlyScenarioConfiguration;
